/* eslint-disable max-len */
import React from 'react';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

const SalesNavigationIcon: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path
            stroke="none"
            fill={color}
            d="M20.7,1.4c0-0.1-0.1-0.3-0.2-0.3C20.4,1,20.2,0.9,20.1,1l-3.4,0.9c-0.2,0.1-0.4,0.2-0.4,0.4
	c0,0.2,0.1,0.4,0.3,0.5l0.7,0.4l-3.9,4.6c-0.1,0.1-0.2,0.1-0.2,0L9.9,5.9l0,0C9.1,5.5,8,5.7,7.4,6.3l-4.7,5.1
	c-0.3,0.3-0.2,0.8,0.1,1l1,0.8c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0,0,0.1,0c0.2,0,0.4-0.1,0.5-0.3L9,8.8c0.1-0.1,0.2-0.1,0.2,0l3.2,1.9
	l0,0c0.8,0.4,1.9,0.2,2.5-0.5l4.7-5.5l0.9,0.5v0c0.2,0.1,0.4,0.1,0.6,0c0.2-0.1,0.3-0.3,0.2-0.5L20.7,1.4z"
        />
        <line x1="0.4" y1="23" x2="23.6" y2="23" />
        <path d="M2.6,23v-6.9c0-0.3,0.3-0.6,0.6-0.6h3.3c0.4,0,0.6,0.3,0.6,0.6V23" />
        <path d="M9.7,23V14c0-0.3,0.3-0.6,0.6-0.6h3.3c0.4,0,0.6,0.3,0.6,0.6V23" />
        <path d="M16.8,23V11.6c0-0.3,0.3-0.6,0.6-0.6h3.3c0.4,0,0.6,0.3,0.6,0.6V23" />
    </SVGWrapper>
);

export default SalesNavigationIcon;
